var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRankPlatinumNoRibbon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.817C8.65 2.817 2.816 8.65 2.816 16c0 1.633.35 3.15.817 4.55L20.55 3.633c-1.4-.583-2.917-.816-4.55-.816z",
    fill: "#99B7DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 3.633L3.632 20.55c1.866 5.133 6.65 8.633 12.366 8.633 7.35 0 13.184-5.95 13.184-13.183 0-5.717-3.5-10.5-8.634-12.367z",
    fill: "#004BAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.517c6.883 0 12.483 5.6 12.483 12.483 0 6.883-5.6 12.483-12.483 12.483-6.883 0-12.483-5.6-12.483-12.483 0-6.883 5.6-12.483 12.483-12.483zM16 2C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2z",
    fill: "#2F8CC2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 8.65c2.917 0 5.017 2.1 5.017 5.017a4.98 4.98 0 01-5.017 5.016h-2.566v4.784h-2.8V8.65h5.366zM16.817 16c1.283 0 2.217-1.05 2.217-2.333 0-1.284-.934-2.334-2.217-2.334h-2.333V16h2.333z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.333c6.417 0 11.667 5.25 11.667 11.667S22.417 27.667 16 27.667 4.333 22.417 4.333 16 9.583 4.333 16 4.333zM16 2C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2z",
    fill: "#2382B4"
  })));
}

export default SvgIconRankPlatinumNoRibbon;